import { styled, Stack, Text, Link } from '@ltvco/refresh-lib/theme';

export const LegalFooterStyled = styled(Stack)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(11),
  lineHeight: 1.6,
  marginTop: theme.spacing(4),
  alignItems: 'center',
  justifyContent: 'center',
}));

export const LegalFooterContent = styled(Text)(({ theme }) => ({
  textAlign: 'center',
  align: 'center',
  marginTop: theme.spacing(2),
}));

export const LegalFooterLinks = styled(Link)(({ theme }) => ({
  color: theme.palette.text.primary,
  cursor: 'pointer',
}));
